export { default as useOutsideClick } from "./use-outside-click";
export type { UseOutsideClickArgs } from "./use-outside-click";
